// extracted by css-extract-rspack-plugin
export default {"fitImage":"ocqn3","columnName":"fm_cy","descriptionIcon":"gUl4R"};